import { FinancialEntity } from "../../../../../../../contexts/chartofaccounts/ChartOfAccountsContext";
import { MVRNavigationAccount } from "../useMonthlyVarianceModalData";

export function buildMVRModalAccountList(financialEntities: FinancialEntity[]): MVRNavigationAccount[] {
    return financialEntities.map(fe => ({
        id: fe.id,
        glName: fe.name,
        glNumber: fe.number
    }));
}